"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import Link from "@/components/Link";
import { Button, Box as MantineBox } from "@mantine/core";
import { analyticsReports } from "@/lib/shared/constants";

import styles from "./styles.module.scss";

interface AnalyticsMenuProps {
  isOpen: boolean;
  onToggle: () => void;
}

const AnalyticsMenu = ({ isOpen, onToggle }: AnalyticsMenuProps) => {
  const pathname = usePathname();

  useEffect(() => {
    if (isOpen) {
      onToggle();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const isActive = pathname.startsWith("/reports");

  return (
    <MantineBox
      className={styles.infoMenuContainer}
      onMouseEnter={() => {
        if (!isOpen) onToggle();
      }}
      onMouseLeave={() => {
        if (isOpen) onToggle();
      }}
    >
      <Button onClick={onToggle} variant="unstyled" data-active={isActive} aria-expanded={isOpen}>
        REPORTS
      </Button>
      <MantineBox className={styles.infoMenu} data-open={isOpen}>
        {analyticsReports.map(({ label, slug }) => (
          <Link
            key={slug}
            href={`/reports/${slug}`}
            prefetch={false}
            data-active={pathname === `/reports/${slug}`}
          >
            {label}
          </Link>
        ))}
      </MantineBox>
    </MantineBox>
  );
};

export default AnalyticsMenu;
